var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76347 2.50544C9.33263 2.50544 8.921 2.6757 8.616 2.9807L8.25793 3.33877H4.09127C3.98084 3.33721 3.8712 3.35761 3.76873 3.39879C3.66626 3.43997 3.57299 3.5011 3.49435 3.57864C3.41571 3.65618 3.35326 3.74857 3.31064 3.85045C3.26801 3.95233 3.24606 4.06167 3.24606 4.17211C3.24606 4.28254 3.26801 4.39188 3.31064 4.49376C3.35326 4.59564 3.41571 4.68804 3.49435 4.76557C3.57299 4.84311 3.66626 4.90424 3.76873 4.94542C3.8712 4.9866 3.98084 5.007 4.09127 5.00544H17.4246C17.535 5.007 17.6447 4.9866 17.7471 4.94542C17.8496 4.90424 17.9429 4.84311 18.0215 4.76557C18.1002 4.68804 18.1626 4.59564 18.2052 4.49376C18.2479 4.39188 18.2698 4.28254 18.2698 4.17211C18.2698 4.06167 18.2479 3.95233 18.2052 3.85045C18.1626 3.74857 18.1002 3.65618 18.0215 3.57864C17.9429 3.5011 17.8496 3.43997 17.7471 3.39879C17.6447 3.35761 17.535 3.33721 17.4246 3.33877H13.2579L12.8999 2.9807C12.5957 2.6757 12.1832 2.50544 11.7524 2.50544H9.76347ZM4.39563 6.67211L5.66841 17.7252C5.77841 18.5502 6.48877 19.1721 7.32043 19.1721H14.1938C15.0255 19.1721 15.7366 18.5512 15.8474 17.7187L17.1202 6.67211H4.39563Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.a15bf0fabb129925f0c1b85a767e2f72.svg";
export { ForwardRef as ReactComponent };